export function downloadICS(eventConfig) {
  const title = eventConfig.name;
  const description = eventConfig.description;
  const start = eventConfig.startUTC;
  const end = eventConfig.endUTC;
  const location = eventConfig.location;
  const icsContent = `BEGIN:VCALENDAR\nVERSION:2.0\nBEGIN:VEVENT\nSUMMARY:${title}\nDESCRIPTION:${description}\nDTSTART:${start}\nDTEND:${end}\nLOCATION:${location}\nEND:VEVENT\nEND:VCALENDAR`;
  const blob = new Blob([icsContent.replace(/\n/g, '\r\n')], {
    type: 'text/calendar',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'evento-test-med.ics';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function openGoogleCalendar(eventConfig) {
  const text = encodeURIComponent(eventConfig.name);
  const details = encodeURIComponent(eventConfig.description);
  const location = encodeURIComponent(eventConfig.location);
  const dates = `${eventConfig.startUTC}/${eventConfig.endUTC}`;
  const url = `https://www.google.com/calendar/render?action=TEMPLATE&text=${text}&dates=${dates}&details=${details}&location=${location}`;
  window.open(url, '_blank');
}

/**
 * Detects the user's operating system
 * @returns {string} - 'apple', 'windows', 'linux', or 'unknown'
 */
export function detectOS() {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/mac|iphone|ipad|ipod/.test(userAgent)) {
    return 'apple';
  } else if (/windows|win32/.test(userAgent)) {
    return 'windows';
  } else if (/linux/.test(userAgent)) {
    return 'linux';
  }

  return 'unknown';
}

/**
 * Smart calendar handler - routes to the best option based on user's device
 * Apple devices → ICS download (works best with Apple Calendar)
 * Other devices → Google Calendar (most universal)
 * @param {object} eventConfig - Event configuration object
 */
export function handleAddToCalendar(eventConfig) {
  const os = detectOS();

  if (os === 'apple') {
    downloadICS(eventConfig);
  } else {
    openGoogleCalendar(eventConfig);
  }
}
